// KNEE PROMPTS

const acl_tear = 
{
  "name": "ACL Tear",
  "meta": {
    links: [
      { label: "ACL Tear", url: "https://www.myorthopedicproblem.com/services/acltear" }
    ]
  },
  "conditions": {
    "age": "35 or younger,36-50",
    "cause": "sports_injury",
    "pain_description": "acute,intermittent",
    "swelling": "moderate,severe",
    "weightbearing_instability": "moderate,severe",
    "rom": "painful_or_unable",
    "popping_snapping_catching": "yes",
    "grinding": "no",
    "pain_location": "patella,entire_knee"
  }
}

const osteochondral_defect = 
{
  "name": "Osteochondral Defect",
  "meta": {
    links: [
      { label: "Osteochondral Defect", url: "https://www.myorthopedicproblem.com/services/osteochondral-defect" }
    ]
  },
  "conditions": {
    "age": "35 or younger",
    "cause": "sports_injury",
    "pain_description": "chronic",
    "swelling": "none,moderate",
    "weightbearing_instability": "none,moderate",
    "rom": "painful_or_unable,decreasing,limited",
    "popping_snapping_catching": "no",
    "grinding": "yes"
  }
}

const meniscal_tear = 
{
  "name": "Meniscal Tear",
  "meta": {
    links: [
      { label: "Meniscal Tear", url: "https://www.myorthopedicproblem.com/services/meniscaltear" }
    ]
  },
  "conditions": {
    "pain_description": "acute,chronic",
    "swelling": "moderate,severe",
    "weightbearing_instability": "moderate,severe",
    "rom": "painful_or_unable,decreasing,limited",
    "popping_snapping_catching": "no",
    "grinding": "no",
    "pain_location": "outer_lateral,inner_medial"
  }
}

const patella_pain_sub = 
{
  "name": "Patella Pain/Subluxation",
  "meta": {
    links: [
      { label: "Patella Pain/Subluxation", url: "https://www.myorthopedicproblem.com/services/patellapainsubluxation" }
    ]
  },
  "conditions": {
    "age": "35 or younger",
    "cause": "arthritis_tendonitis,unknown",
    "pain_description": "chronic",
    "swelling": "moderate,severe",
    "weightbearing_instability": "moderate,severe",
    "rom": "painful_or_unable,decreasing,limited",
    "popping_snapping_catching": "no",
    "grinding": "yes",
    "pain_location": "patella"
  }
}

const osgood_shlater_disease = 
{
  "name": "Osgood Shlater Disease",
  "meta": {
    links: [
      { label: "Osgood-Schlatter Disease", url: "https://www.myorthopedicproblem.com/services/osgood-schlatter-disease" }
    ]
  },
  "conditions": {
    "age": "35 or younger",
    "cause": "arthritis_tendonitis",
    "pain_description": "acute,intermittent,chronic",
    "swelling": "moderate,severe",
    "weightbearing_instability": "moderate,severe",
    "popping_snapping_catching": "no",
    "grinding": "no",
    "pain_location": "patella"
  }
}

const advanced_arthritis_knee = 
{
  "name": "Advanced Arthritis of the Knee",
  "meta": {
    links: [
      { label: "Arthritis in the Knee", url: "https://www.myorthopedicproblem.com/services/arthritis-in-the-knee" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80,81 or older",
    "cause": "arthritis_tendonitis",
    "pain_description": "chronic",
    "swelling": "moderate,severe",
    "rom": "painful_or_unable,decreasing,limited",
    "popping_snapping_catching": "no",
    "grinding": "yes"
  }
}




module.exports = {
  acl_tear,
  osteochondral_defect,
  meniscal_tear,
  patella_pain_sub,
  osgood_shlater_disease,
  advanced_arthritis_knee,
}